<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/7ePQC8/tc-custom/9780226824123.jpg?1731009026803" alt="This image is the cover for the book Huxleys"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Huxleys
      </h1>
      <p class="bookDescription body article font2">
        <b>A <i>New Yorker</i> and <i>Economist</i> Best Book of the Year<br/><br/> Two hundred years of modern science and culture told through one family history.<br/>  </b><br/> This momentous biography tells the story of the Huxleys: the Victorian natural historian T. H. Huxley (“Darwin’s Bulldog”) and his grandson, the scientist, conservationist, and zoologist Julian Huxley. Between them, they communicated to the world the great modern story of the theory of evolution by natural selection. In <i>The Huxleys</i>, celebrated historian Alison Bashford writes seamlessly about these omnivorous intellects together, almost as if they were a single man whose long, vital life bookended the colossal shifts in world history from the age of sail to the Space Age, and from colonial wars to world wars to the cold war.<br/><br/> The Huxleys’ specialty was evolution in all its forms—at the grandest level of species, deep time, the Earth, and at the most personal and intimate. They illuminated the problems and wonders of the modern world and they fundamentally shaped how we see ourselves, as individuals and as a species.<br/><br/> But perhaps their greatest subject was themselves. Bashford’s engaging, brilliantly ambitious book interweaves the Huxleys’ momentous public achievements with their private triumphs and tragedies. The result is the history of a family, but also a history of humanity grappling with its place in nature. This book shows how much we owe—for better or worse—to the unceasing curiosity, self-absorption, and enthusiasm of a small, strange group of men and women.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alison Bashford
      </h2>
      
      <p class="authorDescription body article"><B>Alison Bashford</B> is Scientia Professor in History, director of the Laureate Centre for History and Population, and codirector of the New Earth Histories Research Program at the University of New South Wales in Australia. In 2021, she received the Dan David Prize for her contributions to the history of medicine.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?36263334